/**
 * Normalizes a string for diacritic- and case-insensitive search.
 *
 * Uses NFD to decompose accented characters (e.g. "ç" -> "c" + U+0327,
 * "ã" -> "a" + U+0303) and strips the combining marks (range U+0300..U+036F),
 * so "ação" matches "acao".
 */
export function normalizeForSearch(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
}
